import React, { useEffect } from "react";

const MlAnalysisLanding = () => {
  useEffect(() => {
    document.title =
      "SmartLend — AI Bank Statement Analysis for SME Lenders | Live DSR, FCC & Credit Scoring";
  }, []);

  return (
    <iframe
      title="SmartLend ML Analysis Landing Page"
      src="/ml-analysis-template.html?v=20260521-white-footer-logo"
      style={{
        display: "block",
        width: "100%",
        height: "100vh",
        border: "0",
        background: "#ffffff",
      }}
    />
  );
};

export default MlAnalysisLanding;
